<h1>Albion Online Tutorials and Articles</h1>
<h2>A collection of unique Albion Online information</h2>
<div style="display: flex; flex-direction: column">
  @if (articleService.articles$ | async; as articles) {
    @for (article of articles; track article.id) {
      <mat-card style="margin-top: 25px">
        <mat-card-header>
          <mat-card-title
            ><a [routerLink]="'/articles/view/' + article.id">{{ article.title }}</a></mat-card-title
          >
          <mat-card-subtitle style="font-style: italic; font-size: 12px"
            ><p>Published: {{ article.createdAt | date: 'fullDate' : 'UTC' }} by {{ article.author }}</p>
            @if ((article.createdAt | date: 'fullDate' : 'UTC') !== (article.updatedAt | date: 'fullDate' : 'UTC')) {
              <p>Last Update: {{ article.updatedAt | date: 'fullDate' : 'UTC' }}</p>
            }
          </mat-card-subtitle>
        </mat-card-header>
        <mat-card-content style="margin: 10px 0px">
          <p>{{ article.summary }}</p>
        </mat-card-content>
        <mat-card-actions>
          <a color="accent" mat-button [routerLink]="'/articles/view/' + article.id" aria-label="View Article">VIEW</a>
          <button color="accent" mat-button (click)="articleService.copyArticleLink(article.id)" aria-label="Copy link for Article">COPY LINK</button>
        </mat-card-actions>
      </mat-card>
    }
  } @else {
    <p>Loading...</p>
  }
</div>
